export const CAR = 'CAR';
export const CRUISE = 'CRUISE';
export const FLIGHT = 'FLIGHT';
export const HOTEL = 'HOTEL';
export const PACKAGE = 'PACKAGE';
export const PRODUCT_ICONS = [CAR, CRUISE, FLIGHT, HOTEL, PACKAGE];